/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowUpRight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M200,64V168a8.00053,8.00053,0,0,1-13.65723,5.65723L140,127.314,69.65674,197.65723a8.00018,8.00018,0,0,1-11.31348-11.31446L128.686,116,82.34277,69.65723A8.00038,8.00038,0,0,1,88,56H192A8.00039,8.00039,0,0,1,200,64Z" />
    </Svg>
  );
}

export default ArrowUpRight;
